<template>
  <!-- 贷款信息说明 -->
  <div>
    <div class="explainCon">
      <h3 style="text-align: center;">重要提示</h3>
      <div><span>1、贷款人：</span><span>吉林亿联银行股份有限公司</span></div>
      <div><span>2、咨询与投诉电话：</span></div>
      <div><span>{{explainInfo.company}}</span> 客服电话：{{ explainInfo.telNo }}</div>
      <div>亿联银行客服电话：95396，如涉及合作机构咨询与投诉事项，您也可以联系亿联银行协助转办。</div>
      <div><span>3、贷款用途：</span><span>生产经营(本贷款不得用于购房和投资股票、理财等生产经营以外的其他用途)</span></div>
      <div><span>4、贷款条件：</span><span>根据《个人贷款管理暂行办法》贷款条件为：</span></div>
      <div>（1）借款人必须是具有完全民事行为能力的中华人民共和国公民；</div>
      <div>（2）贷款用途明确合法；</div>
      <div>（3）借款人具备还款意愿和还款能力；</div>
      <div>（4）借款人信用状况良好，无重大不良信用记录；</div>
      <div>（5）贷款申请金额、期限合理；</div>
      <div>（6）本行要求的其他条件。</div>
      <div><span>5、年化综合资金成本：</span><span>18%以内</span></div>
      <div>本次申请贷款的银行利率为年化8%-15%（单利），借款人所有应还费用除了银行收取的本金、利息、罚息外，其余为担保主体收取的担保费用。</div>
      <div><span>6、还本付息方式：参见还款计划</span></div>
      <div><span> 7、我行合作的逾期清收主体：</span><span>我行合作的逾期清收公司详见我行官网。</span></div>
      <div><span>8、助贷引流服务：</span><span>{{explainInfo.company}}为亿联银行“亿票贷”产品提供贷款引流服务，亿联银行根据自身信贷政策对{{explainInfo.company}}推荐的借款人进行独立审核和放款。</span></div>
      <div><span>9、违约责任：</span><span>在业务存续期间，按业务各项合同约定若出现违约情况，需由违约方承担相应责任。</span></div>
      <div>10.我行合作的支付结算机构：详见我行官网公示。</div>
      <div>11.该笔贷款由黑龙江省银鼎融资担保有限公司(简称“担保公司”)提供担保，如贷款逾期后，将由担保公司代偿，根据我行与担保公司合作协议约定，代偿后的逾期贷款的债权将转交担保公司，该逾期贷款由担保公司负责催收，如有对催收产生异议，请联系担保公司或贷款平台协商解决，联系电话：0451-55569345。</div>
    </div>
    <div class="btnBox">
      <Button
        :text="btnText"
        type="danger"
        class="nextStep"
        :disabled="isDisabled"
        :click="goToNextPage"
      />
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import Button from '@/components/Button.vue';

export default {
  name: 'loanInfoExplain',
  data() {
    return {
      time: 5,
      explainInfo: {},
    };
  },
  components: {
    Button,
  },
  mounted() {
    this.getContractInfo();

    setInterval(() => {
      this.time > 0 ? --this.time : this.time;
    }, 1000);
  },
  methods: {
    ...mapMutations('commonForms', ['updateForm']),

    async getContractInfo() {
      const { data, success, returnMessage } = await this.$api.OtherPage.queryEchoInfo({
        pageId: '11', // 0:进件页面 1:授信合同签署页面 2:提款申请页面 3:提款合同签署页面 4:还款试算页面 10:签署担保合同
        orderId: this.$route.query.orderId,
      });
      if (!success) {
        this.$toast(returnMessage || '获取数据失败');
        return;
      }
      this.explainInfo = data;
      this.$toast.clear();
    },
    // 后端控制页面跳转
    goToNextPage() {
      this.jumpCurrPage();
    },
    // 后端进行跳转
    jumpCurrPage() {
      const { orderId } = this.$route.query;
      this.$api.PublicPage.jumpCurrPage({
        orderId: orderId || localStorage.getItem('orderId'),
      }).then((res) => {
        if (res.success) {
          if (res.data) {
            window.location.href = res.data;
          }
        } else {
          this.$dialog.alert({
            title: '提示',
            message: '操作失败',
          });
        }
      });
    },
  },
  computed: {
    ...mapState({
      commonForms(val) {
        return val.commonForms;
      },
    }),
    isDisabled() {
      return this.time > 0;
    },
    btnText() {
      return this.time > 0 ? `（ ${this.time} ）下一步` : '下一步';
    },
  },
};
</script>
<style lang="scss" scoped>
.signingSecurityContractStyle {
  width: 100%;
  height: 100%;
  background-color: #fff;
  box-sizing: border-box;
  padding: 15px;
  font-size: 15px;
  >>> .agreement {
    margin-left: 0px;
    margin-top: 20px;
  }
}
.contentStyle {
  box-shadow: border-box;
  padding-left: 40px;
  text-align: left;
}
.btnBox {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  padding-left: 15px;
  padding-right: 15px;
  margin-top: 15px;
}
.nextStep {
  width: 100%;
  padding: 0;
  border-radius: 3px;
  margin-top: 10px;
}
.submitTips {
  font-size: 12px;
  color: #c7c7c7;
  padding: 15px;
  text-align: left;
}
.explainCon {
  font-size: 12px;
  color: #666;
  padding: 15px;
  text-align: left;
  div > span:first-child{
    font-weight: bold;
  }
}
</style>
